import { MenuItem } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import StaticSelector from "components/Atoms/StaticSelector"
import { isFunction } from "lodash-es"
import React from "react"
import DynamicValue from "./DynamicValue"

const TemplateFilter = ({
  filter,
  disabled = false,
  className = null,
  index,
  onRemove,
  allFilters,
  filters,
  basePath = null,
  children = null,
}) => {
  const path = basePath ? `${basePath}.${index}.field` : `${index}.field`

  return (
    <div className={className}>
      {isFunction(children) ? children(path) : null}
      <StaticSelector
        fill
        label="Field"
        items={allFilters}
        path={path}
        renderText={item => item?.alias ?? "-- Select --"}
        itemRenderer={(item, props) => {
          const { modifiers, handleClick } = props
          return (
            <MenuItem
              disabled={filters?.some?.(i => i.field?.id === item.id) || false}
              active={modifiers.active}
              key={item.id}
              onClick={handleClick}
              text={item?.alias}
            />
          )
        }}
      />
      {filter?.isRangeValue ? (
        <div className="flex">
          <DynamicValue index={index} item={filter} path={`${path}.value.0`} />
          <DynamicValue
            className="ml-3"
            index={index}
            item={filter}
            path={`${path}.value.1`}
          />
        </div>
      ) : (
        <DynamicValue
          index={index}
          item={filter}
          path={
            filter?.fieldType === "ARRY" ? `${path}.value` : `${path}.value.0`
          }
        />
      )}
      <div className="flex items-start mt-4">
        <CustomButton
          disabled={disabled}
          icon="trash"
          intent={disabled ? "none" : "danger"}
          minimal
          onClick={e => onRemove(index)}
        />
      </div>
    </div>
  )
}

export default TemplateFilter
